import styled from 'styled-components';
import { breakPoints } from '~/styles/break-points';

export const TechnicalDataEntryWrapper = styled.li`
	display: grid;
	column-gap: 8px;
	row-gap: 4px;
	border-bottom: 1px solid #000;
	padding-top: 16px;
	padding-bottom: 16px;

	${breakPoints({
		'768': `
			grid-template-columns: repeat(2, 1fr);
			border-bottom: none;
			padding-top: 0;
			padding-bottom: 0;
		`,
	})};

	.technical-item {
		${breakPoints({
			'768': `
				border-bottom: 1px solid #000;
				padding-top: 16px;
				padding-bottom: 16px;
			`,
		})};
	}
`;
